export default {
  signup: {
    pageTitle: 'Registro',
    register: 'Criar uma conta',
    signupWithGithub: 'Se registrar com GitHub',
    processingRegistration: 'Processando o cadastro'
  }
}
